import { NgModule } from '@angular/core';
import { ProgressBarButtonComponent } from './progress-bar-button.component';

@NgModule({
  imports: [ProgressBarButtonComponent],
  exports: [ProgressBarButtonComponent]
})
export class ProgressBarButtonModule {}
